/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;
/** 3.物理エンジン */
export const template3 = {
  title: t.to('物理エンジン', 'title3'),
  desc: t.to(
    '物体に重力をかけたり、物体同士のぶつかりを表現するには物理エンジンのカテゴリから「動きのある物質にする」属性を物体に追加します。「動きのない物体にする」属性は、床や壁などに設定します。',
    'desc3'
  ),
  img: '../public/template/3.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <block type="a-scene-start" x="110" y="110">
    <statement name="IN">
      <block type="sphere_v2">
        <field name="id">block1</field>
        <field name="position-x">0</field>
        <field name="position-y">3</field>
        <field name="position-z">1</field>
        <value name="COLOUR">
          <shadow type="color_value_v2">
            <field name="COLOUR">#ff0000</field>
          </shadow>
        </value>
        <value name="ATTR">
          <block type="scale_v2">
            <field name="scale-x">0.5</field>
            <field name="scale-y">0.5</field>
            <field name="scale-z">0.5</field>
            <value name="ATTR">
              <block type="a-dynamic-body_v2">
                <field name="mass">5</field>
                <field name="shape">sphere</field>
              </block>
            </value>
          </block>
        </value>
        <next>
          <block type="cube_v2">
            <field name="id">block2</field>
            <field name="position-x">2</field>
            <field name="position-y">9</field>
            <field name="position-z">-2</field>
            <value name="COLOUR">
              <shadow type="color_value_v2">
                <field name="COLOUR">#ffd100</field>
              </shadow>
            </value>
            <value name="ATTR">
              <block type="scale_v2">
                <field name="scale-x">1</field>
                <field name="scale-y">9</field>
                <field name="scale-z">1</field>
                <value name="ATTR">
                  <block type="a-dynamic-body_v2">
                    <field name="mass">5</field>
                    <field name="shape">box</field>
                  </block>
                </value>
              </block>
            </value>
            <next>
              <block type="cube_v2">
                <field name="id">block3</field>
                <field name="position-x">-2</field>
                <field name="position-y">5</field>
                <field name="position-z">-1</field>
                <value name="COLOUR">
                  <shadow type="color_value_v2">
                    <field name="COLOUR">#1800ff</field>
                  </shadow>
                </value>
                <value name="ATTR">
                  <block type="a-dynamic-body_v2">
                    <field name="mass">5</field>
                    <field name="shape">box</field>
                  </block>
                </value>
                <next>
                  <block type="cube_v2">
                    <field name="id">block4</field>
                    <field name="position-x">0</field>
                    <field name="position-y">1</field>
                    <field name="position-z">-1</field>
                    <value name="COLOUR">
                      <shadow type="color_value_v2">
                        <field name="COLOUR">#35952f</field>
                      </shadow>
                    </value>
                    <value name="ATTR">
                      <block type="scale_v2">
                        <field name="scale-x">6</field>
                        <field name="scale-y">0.2</field>
                        <field name="scale-z">6</field>
                        <value name="ATTR">
                          <block type="a-static-body_v2">
                          </block>
                        </value>
                      </block>
                    </value>
                    <next>
                      <block type="environment_v2">
                        <field name="preset">forest</field>
                      </block>
                    </next>
                  </block>
                </next>
              </block>
            </next>
          </block>
        </next>
      </block>
    </statement>
  </block>
</xml>`,
};
